export default {
  title: "",
  subtitle: "Customer KYC and upload of documents",
  path: "customer_kyc",
  paragraphs: ["All new customers are initially registered and approved as level-1, even when no documentation is provided in the first registration.", 
    "After the customer reaches the limit of 20k USD transacted annually, if any mandatory document is missing, the next payment he’ll do will have the flag cleared=false, and a webhook will be sent to you with the documents needed to be uploaded – you can check this in section 'Webhooks related to customer/payers'.",
    "Below are the status and how a reproved customer that has not sent his documents for analysis is shown. If money is sent from/to this customer, the transaction will remain on hold (cleared = false) until it is approved again."
  ],
  request: {
    responses: {
      "data": {
        "updated_at": "2023-03-17T18:27:39.671478",
        "status": "reproved",
        "social_name": "Luiz Abreu Neto",
        "required_clearance_level": 2,
        "references": [],
        "phone_number": "119999999999",
        "net_monthly_average_income": "7000.00",
        "id": "a7e3346b-f6fd-4380-bbfc-c6fc51507820",
        "fiscal_country": "Brasil",
        "email": "luizan@hotmail.com",
        "documents": [],
        "document_type": "cpf",
        "document_number": "61558254676",
        "clearance_level": 1,
        "birth_date": "1990-10-10",
      }
    }
  },
  domainsProperties: [
    {
      name: "approved",
      values: "Customer are able to send/receive money through the platform. No action is needed on your side."
    },
    {
      name: "reproved",
      values: "Customer are required to send documents for review, or it had already been sent but it had been rejected by KYC, in this case you will need to provide new ones."
    },
    {
      name: "waiting_approval",
      values: "Customer have sent the KYC documents but are waiting for the analysis from the backoffice. No action is needed on your side."
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/SubjectPeople/CustomerKYC.js